import { IconButton } from "@material-ui/core"
import NextLink from "common/bit/NextLink"
import FacebookIcon from "reusable/icons/FacebookIcon"

import InstagramIcon from "reusable/icons/InstagramIcon"
import YoutubeIcon from "reusable/icons/YoutubeIcon"
import styled from "styled-components"
import { StyledRow } from "theme/shared"

const StyledWrapper = styled.div`
  margin-top: auto;
  ${(p) => p.theme.breakpoints.down("sm")} {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
const StyledIconButton = styled(IconButton)`
  padding: 1px;
`
const SocialButtonsRow = () => {
  return (
    <StyledWrapper>
      <StyledRow $gap="20px">
        {/* <StyledIconButton>
          <TwitterIcon />
        </StyledIconButton> */}
        <NextLink
          href="https://www.youtube.com/user/MazdaIL"
          passHref
          openInNewTab
        >
          <StyledIconButton aria-label="youtube">
            <YoutubeIcon />
          </StyledIconButton>
        </NextLink>
        <NextLink
          href="https://www.instagram.com/mazda_il/?hl=en"
          passHref
          openInNewTab
        >
          <StyledIconButton aria-label="instagram">
            <InstagramIcon />
          </StyledIconButton>
        </NextLink>
        <NextLink
          href="https://www.facebook.com/Mazda.IL"
          passHref
          openInNewTab
        >
          <StyledIconButton arial-label="facebook">
            <FacebookIcon />
          </StyledIconButton>
        </NextLink>
      </StyledRow>
    </StyledWrapper>
  )
}

export default SocialButtonsRow
